import StarIcon from 'assets/icons/star.svg'

export const WinnerTag = () => (
  <div className="w-[93px] h-8 bg-[#EBFF00] px-2 py-1 flex border-[2px] border-solid border-black rounded-8 items-center">
    <span className="text-[12px] tracking-[0%] font-bold leading-6 font-TCCC">WINNER</span>{' '}
    <img src={StarIcon} alt="Star" className="ml-1 h-[14px] w-[14px]" />
  </div>
)
